import { Assets } from './Assets'

export const AllLiabilities = ({ liabilities, handleOnClick }) => {
  const allLiabilities = liabilities || []
  return (
    <Assets
      assets={allLiabilities}
      handleOnClick={handleOnClick}
      category={'AllLiabilities'}
    />
  )
}
